import { MouseEventHandler } from 'react';
import { SSPollAnswerText } from '../../../atoms/self-service';

interface SSPollAnswerProps {
    answer: string;
    index: number;
    onClick: MouseEventHandler<HTMLButtonElement>;
    classNames?: string | boolean;
}

export const SSPollAnswer = ({ answer, index, onClick, classNames }: SSPollAnswerProps) => (
    <button
        type="button"
        className="group relative block w-full hover:bg-lighter-blue focus-visible:bg-lighter-blue focus-visible:-outline-offset-2 border-b last:border-0 border-dashed border-primary cursor-pointer py-3 pl-11 text-left transition-all duration-300 select-none"
        onClick={onClick}
    >
        <SSPollAnswerText answer={answer} index={index} classNames={classNames} />
    </button>
);
